export default __webpack_public_path__ + "static/media/IRTradeLogo.e379bded.svg";